import React, { useContext, useMemo, useState } from "react";
import "./ObjectionPanel.css";
import { formatter } from "../../../utils/helpers";
import { COMP_FIELDS2 } from "../../../utils/Compensation";
import { Context } from "../../../context/Context";
import { translations } from "../../../utils/lang";
import { Button, Input, Checkbox, Upload } from "../../ui";

const toNumber = (value) => Number.parseFloat(value || 0) || 0;

export const ObjectionPanel = ({ app, month, loading, orders, onCancel, onSubmit }) => {
  const { lang } = useContext(Context);
  const [objectionState, setObjectionState] = useState([]);
  const [errors, setErrors] = useState({});

  const orderRows = useMemo(() => {
    return Object.entries(orders || {}).map(([orderId, orderItems]) => {
      const summary = orderItems.reduce(
        (acc, item) => {
          acc.totalOrder += toNumber(item[COMP_FIELDS2.orderAmount]);
          acc.totalEndurance += toNumber(item[COMP_FIELDS2.enduranceAmount]);
          acc.totalRefund += toNumber(item[COMP_FIELDS2.refundAmount]);
          return acc;
        },
        { totalOrder: 0, totalEndurance: 0, totalRefund: 0 }
      );

      return {
        orderId,
        items: orderItems,
        details: orderItems[0],
        summary,
      };
    });
  }, [orders]);

  const selectedMap = useMemo(() => {
    return new Map(objectionState.map((order) => [order.orderId, order]));
  }, [objectionState]);

  const toggleOrderSelection = (orderId, order) => {
    setObjectionState((prev) => {
      const exists = prev.find((o) => o.orderId === orderId);
      if (exists) {
        setErrors((prevErr) => {
          const { [orderId]: _, ...rest } = prevErr;
          return rest;
        });
        return prev.filter((o) => o.orderId !== orderId);
      }

      return [...prev, { ...order, orderId, img: null, note: "" }];
    });
  };

  const handleOrderImages = (orderId, file) => {
    setObjectionState((prev) =>
      prev.map((order) => (order.orderId === orderId ? { ...order, img: file } : order))
    );
    setErrors((prev) => ({ ...prev, [orderId]: { ...prev[orderId], img: false } }));
  };

  const handleNoteChange = (orderId, value) => {
    setObjectionState((prev) =>
      prev.map((order) => (order.orderId === orderId ? { ...order, note: value } : order))
    );
    setErrors((prev) => ({ ...prev, [orderId]: { ...prev[orderId], note: false } }));
  };

  const handleSubmit = () => {
    let hasError = false;
    const newErrors = {};

    objectionState.forEach((order) => {
      const orderErrors = {};

      if (!order.note.trim()) {
        orderErrors.note = true;
        hasError = true;
      }

      if (!order.img) {
        orderErrors.img = true;
        hasError = true;
      }

      if (Object.keys(orderErrors).length > 0) {
        newErrors[order.orderId] = orderErrors;
      }
    });

    setErrors(newErrors);
    if (hasError) return;
    if (onSubmit) onSubmit(objectionState);
  };

  return (
    <div className="objection-panel-container">
      <div className="objection-panel">
        <p>
          {translations[lang].objection.title} {app} - {month}
        </p>

        {orderRows.map(({ orderId, details, summary }) => {
          const selectedOrder = selectedMap.get(orderId);

          return (
            <div key={orderId} className="branchesFaults-objection-card orderId">
              <Checkbox
                checked={Boolean(selectedOrder)}
                onChange={() => toggleOrderSelection(orderId, details)}
              />

              <div className="branchFaults-expand-card-col">
                <div className="branchesFaults-p center orderId">
                  <p>
                    <strong>{orderId}</strong>
                  </p>
                </div>
                <div className="branchesFaults-p">
                  <p>
                    {details[COMP_FIELDS2.date]} {details[COMP_FIELDS2.time]}
                  </p>
                </div>
                <div className="branchesFaults-p">{details[COMP_FIELDS2.orderStatus]}</div>
              </div>

              <div className="branchesFaults-p col">
                <strong>{translations[lang].reports.details.body[4]}</strong>{" "}
                {details[COMP_FIELDS2.cause]}
              </div>
              <div className="branchesFaults-p">{formatter.format(summary.totalOrder)}</div>
              <div className="branchesFaults-p">{formatter.format(summary.totalEndurance)}</div>
              <div className="branchesFaults-p">{formatter.format(summary.totalRefund)}</div>
{selectedOrder && (
  <div className="objection-extra-fields">
    <div className="objection-note-container">
      <Input
        textarea
      
        placeholder={translations[lang].objection.note}
        value={selectedOrder.note}
        onChange={(e) => handleNoteChange(orderId, e.target.value)}
        error={
          errors[orderId]?.note
            ? lang === "ar"
              ? "الرجاء إدخال الملاحظة"
              : "Please enter a note"
            : ""
        }
      />
    </div>

    <div className="objection-note-container">
      <label className="objection-upload-box">
        <Upload size={18} />
        <span>
          {selectedOrder.img?.name ||
            (lang === "ar" ? "إرفاق الصورة" : "Upload image")}
        </span>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleOrderImages(orderId, e.target.files?.[0] || null)}
        />
      </label>

      {errors[orderId]?.img && (
        <span className="error-text">
          {lang === "ar" ? "الرجاء إرفاق الصورة" : "Please upload an image"}
        </span>
      )}
    </div>
  </div>
)}
            </div>
          );
        })}

        <div className="objection-btns">
          <Button loading={loading} disabled={loading} variant="primary"  appearance="filled" fullWidth onClick={handleSubmit}>
            {translations[lang].objection.submit}
          </Button>
          <Button disabled={loading} variant="danger" appearance="soft" fullWidth onClick={onCancel}>
            {translations[lang].objection.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
};